import searchQuery from './atom';

export default searchQuery;
